import SFetch from '@app/utils/sfetch'
import type { PinnedSegment } from './types'

const firmId = (): string => window.Silverfin.currentFirmId

export type PinnedSegmentsResponse = {
  pinned_segments: PinnedSegment[]
}

type PinTarget = { segmentId?: number | null; partnerSegmentId?: number | null }

type PinBody = {
  segment_id: number | null
  partner_segment_id: number | null
}

const buildPinBody = ({ segmentId, partnerSegmentId }: PinTarget): PinBody => ({
  segment_id: segmentId ?? null,
  partner_segment_id: partnerSegmentId ?? null,
})

const emptyPinnedSegments: PinnedSegmentsResponse = {
  pinned_segments: [],
}

export const pinSegment = async (
  target: PinTarget
): Promise<PinnedSegmentsResponse> => {
  const response = await SFetch.json<PinnedSegmentsResponse>(
    window.Silverfin.Routes.insights_pinned_segments_path(firmId()),
    { method: 'POST', body: buildPinBody(target) },
    { camelizeJSON: false }
  )
  return response ?? emptyPinnedSegments
}

export const unpinSegment = async (
  target: PinTarget
): Promise<PinnedSegmentsResponse> => {
  const response = await SFetch.json<PinnedSegmentsResponse>(
    window.Silverfin.Routes.insights_pinned_segments_path(firmId()),
    { method: 'DELETE', body: buildPinBody(target) },
    { camelizeJSON: false }
  )
  return response ?? emptyPinnedSegments
}
